import styled, { css } from "styled-components/macro";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
  background-color: #f5f5f5;
`;

export const Backdrop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  width: 100vw;
  height: 300vh;
`;

export const ModalContainer = styled.div`
  position: fixed;
  min-width: 800px;
  min-height: 600px;
  background-color: #ffffff;
  border-radius: 20px;
  top: 1%;
`;

export const SModalContainer = styled.div`
  position: absolute;
	width: 400px;
	background-color: #fff;
	border-radius: 4px;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	.modal-btn-area{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 20px;
	}
	.modal-btn{
		width: 100px;
		padding: 8px 12px;
		background-color: #73972c;
		color: #fff;
		border-radius: 8px;
		border: none;
		margin: 0 4px;
		&:hover{
			cursor: pointer;
		}
	}
`;

export const BoxListModalContainer = styled.div`
  position: fixed;
  min-width: 200px;
  min-height: 500px;
  background-color: #ffffff;
  border-radius: 20px;
  top: 1%;
`;

export const Modals = styled.div`
  width: 100%;
  height: 700px;
  display: inline-block;
  flex-direction: row;
`;

export const SModals = styled.div`
  width: 100%;
  height: 600px;
  display: inline-block;
  flex-direction: row;
	padding: 20px 40px;
`;

export const PageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 15px 40px;
  width: 100%;
  .move-btn {
    width: 30px;
    & img {
      width: 100%;
    }
  }
  .pagetit {
    font-size: 1.13em;
    font-family: "spoqa500";
    margin-left: 10px;
  }
  .post-submit {
    font-size: 1.13em;
    padding: 8px 21px;
    background-color: #73972c;
    color: #fff;
    border-radius: 8px;
    border: none;
    position: absolute;
    right: 40px;
    cursor: pointer;
  }
  .btn-box {
    position: absolute;
    right: 0;
  }
  .submit {
    font-size: 1.13em;
    padding: 8px 21px;
    background-color: #73972c;
    color: #fff;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    margin-right: 10px;
  }

  @media screen and (min-width: 1050px) {
    font-size: 1.4em;
    p {
      & img {
        width: 30%;
      }
    }
  }
`;

export const InfoData = styled.div`
  width: 100%;
  background-color: #fff;
  padding-top: 10px;
  .Date {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 2vw;
  }
`;

export const InfoBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 15px 0px;

  @media screen and (min-width: 1050px) {
  }
`;

export const InfoItem = styled.div`
  width: 20%;
  text-align: center;

  p {
    font-size: 0.88em;
    font-family: "Spoqa500";
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    & img {
      width: 32px;
      border-radius: 50%;
    }
  }
  .insect-name {
    font-size: 1em;
    font-family: "Spoqa500";
  }
  p:first-child {
    font-family: "Spoqa400";
    color: #656565;
    margin-bottom: 10px;
  }

  @media screen and (min-width: 1050px) {
    p {
      font-size: 1.2em;
      & img {
        width: 38px;
        border-radius: 50%;
      }
    }
    .insect-name {
      font-size: 1.3em;
      font-family: "Spoqa500";
    }
  }
`;

export const BreedingBox = styled.div`
  width: 100%;
  background-color: #fff;
  margin-top: 8px;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;

  @media screen and (min-width: 1050px) {
  }
`;

export const BreedingBoxTop = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 40px;

  p {
    font-size: 1em;
    font-family: "Spoqa700";
  }

  @media screen and (min-width: 1050px) {
    p {
      font-size: 1.2em;
      font-family: "Spoqa700";
    }
  }
`;

export const BreedingBoxSelectedTop = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 40px;

  p {
    font-size: 1em;
    font-family: "Spoqa700";
  }

  @media screen and (min-width: 1050px) {
    p {
      font-size: 1.2em;
      font-family: "Spoqa700";
    }
  }
`;

export const BreedingBoxBot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
	width: 100%;
	margin-top: 20px;

  .breedingbox {
    margin-left: 20px;
    background-color: #dddddd;
    padding: 8px 6px;
    border-radius: 5px;
    font-size: 0.63em;

    text-align: center;
    font-family: "Spoqa500";
    cursor: pointer;
  }
  .breedingbox-active {
    margin-left: 20px;
    background-color: #2a3a4b;
    padding: 8px 6px;
    border-radius: 5px;
    font-size: 0.63em;
    font-family: "Spoqa500";
    width: 90px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
  p:first-child {
    margin-left: 0px;
  }
	.breeding-box-list{
		width: 100%;

		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;

		li{
			list-style: none;
			width: 15em;
			min-width: 150px;
			height: 40px;
			text-align: center;
			border: 1px solid #dddddd;
			border-radius: 4px;

			&:not(:last-child){
				margin-bottom: 4px;
			}

			button{
				background-color: unset;
				border: none;
				border-radius: 4px;

				width: 100%;
				height: 100%;

				font-size: 1em;

				transition: all 0.2s ease-in-out;
				&:hover{
					cursor: pointer;
					background-color: rgba(34,193,151,0.2);
				}
				&.checked{
					background-color: #2a3a4b;
					color: #fff;
				}
			}
		}
	}

  @media screen and (min-width: 1050px) {
    .breedingbox {
      margin-left: 15px;
      background-color: #dddddd;
      padding: 12px 8px;
      border-radius: 5px;
      font-size: 0.9em;
      font-family: "Spoqa500";

      cursor: pointer;
    }
    .breedingbox-active {
      margin-left: 20px;
      background-color: #2a3a4b;
      padding: 12px 8px;
      border-radius: 5px;
      font-size: 0.9em;
      font-family: "Spoqa500";
      color: #fff;
      cursor: pointer;
    }
  }
`;

export const BreedingSelectedBoxBot = styled.div`
  display: inline-block;
  align-items: left;
  justify-content: flex-start;
  
  .breedingbox {
    margin-left: 20px;
    background-color: #dddddd;
    padding: 8px 6px;
    border-radius: 5px;
    font-size: 0.63em;
    width: 100px;

    text-align: center;
    font-family: "Spoqa500";
    cursor: pointer;
  }
  .breedingbox-active {
    margin-left: 20px;
    background-color: #2a3a4b;
    padding: 8px 6px;
    border-radius: 5px;
    font-size: 0.63em;
    font-family: "Spoqa500";
    width: 100%;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
  p:first-child {
    margin-left: 0px;
  }

`;

export const BreedingPopBoxBot = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 10px;

  .breedingbox {
    margin-left: 20px;
    background-color: #dddddd;
    padding: 8px 6px;
    border-radius: 5px;
    font-size: 0.63em;
    width: 100px;

    text-align: center;
    font-family: "Spoqa500";
    cursor: pointer;
  }
  .breedingbox-active {
    margin-left: 20px;
    background-color: #2a3a4b;
    padding: 8px 6px;
    border-radius: 5px;
    font-size: 0.63em;
    font-family: "Spoqa500";
    width: 90px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
  p:first-child {
    margin-left: 0px;
  }

  @media screen and (min-width: 1050px) {
    .breedingbox {
      margin-left: 50px;
      background-color: #dddddd;
      padding: 12px 8px;
      border-radius: 5px;
      font-size: 0.9em;
      font-family: "Spoqa500";

      cursor: pointer;
    }
    .breedingbox-active {
      margin-left: 20px;
      background-color: #2a3a4b;
      padding: 12px 8px;
      border-radius: 5px;
      font-size: 0.9em;
      font-family: "Spoqa500";
      color: #fff;
      cursor: pointer;
    }
  }
`;

export const BreedingBoxSmallBot = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 5px;

  .breedingbox {
    margin-left: 20px;
    background-color: #dddddd;
    padding: 8px 6px;
    border-radius: 5px;
    font-size: 0.63em;
    width: 100px;

    text-align: center;
    font-family: "Spoqa500";
    cursor: pointer;
  }
  .breedingbox-active {
    margin-left: 20px;
    background-color: #2a3a4b;
    padding: 8px 6px;
    border-radius: 5px;
    font-size: 0.63em;
    font-family: "Spoqa500";
    width: 90px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
  p:first-child {
    margin-left: 0px;
  }

  @media screen and (min-width: 1050px) {
    .breedingbox {
      margin-left: 20px;
      background-color: #dddddd;
      padding: 12px 8px;
      border-radius: 5px;
      font-size: 0.9em;
      font-family: "Spoqa500";

      cursor: pointer;
    }
    .breedingbox-active {
      margin-left: 20px;
      background-color: #2a3a4b;
      padding: 12px 8px;
      border-radius: 5px;
      font-size: 0.9em;
      font-family: "Spoqa500";
      color: #fff;
      cursor: pointer;
    }
  }
`;

export const EnvironmentalCon = styled.div`
  width: 100%;
  background-color: #fff;
  margin-top: 8px;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
`;

export const Environmentaltit = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 40px;

  .content-tit {
    font-size: 1em;
    font-family: "spoqa700";
  }
  p img {
    cursor: pointer;
    transform: rotate(0deg);
    transition-duration: 1s;
  }
  p img.rotate {
    cursor: pointer;
    transform: rotate(180deg);
    transition-duration: 1s;
  }

  @media screen and (min-width: 1050px) {
    .content-tit {
      font-size: 1.2em;
      font-family: "spoqa700";
    }
  }
`;
export const EnvironmentalHide = styled.div`
  max-height: 1000px;
  overflow: hidden;
  transition-duration: 1s;

  &.hide {
    max-height: 0px;
    overflow: hidden;
    transition-duration: 1s;
  }
`;
export const EnvironmentalBox = styled.div`
  width: 100%;
  background-color: #fff;
  :last-child {
    margin-bottom: 27px;
  }
  .EnvironmentalBox-tit {
    padding: 10px 40px;
    font-family: "Spoqa500";
    font-size: 0.9em;
  }

  @media screen and (min-width: 1050px) {
    .EnvironmentalBox-tit {
      font-size: 1.1em;
    }
  }
`;

export const OutsideAirList = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  padding: 11px 0px;
`;

export const OutsideAirListItem = styled.div`
  border-left: 1px solid #dddddd;
  text-align: center;
  width: 15%;

  :last-child {
    border-right: 1px solid #dddddd;
  }
  .outsideair-item-tit {
    font-size: 0.75em;
    font-family: "spoqa500";
    color: #979797;
  }
  .outsideair-item-content {
    font-family: "spoqa700";
    font-size: 1em;
    margin-top: 8px;
  }

  @media screen and (min-width: 1050px) {
    .outsideair-item-tit {
      font-size: 1em;
      font-family: "spoqa500";
      color: #979797;
    }

    .outsideair-item-content {
      font-family: "spoqa700";
      font-size: 1.2em;
      margin-top: 14px;
    }
  }
`;

export const EnvironmentalGrap = styled.div`
  width: 100%;
  background-color: #f5f5f5;
  padding: 16px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* overflow-y: auto; */
  position: relative;
  /* .grap {
  height: 102px;
  width: 12px;
  border-radius: 9px;
  
} */
`;
export const EnvironmentSample = styled.div`
  position: absolute;
  bottom: 10%;
  right: 5%;
  display: flex;
  align-items: center;
  justify-content: center;

  & .item {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;

    & .sample {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: red;
      margin-right: 5px;
    }
    & .text {
      font-size: 0.88em;
    }
  }
  @media screen and (min-width: 1050px) {
    right: 15%;
    & .item {
      & .sample {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background-color: red;
        margin-right: 5px;
      }
      & .text {
        font-size: 1em;
      }
    }
  }
`;
export const EnvironmentalItemSample = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0px 10% 0px 15%;
  position: relative;

  .env-item-danger {
    font-family: "spoqa700";
    color: #ff0000;
    font-size: 0.88em;
    width: 30px;
  }
  .env-item-Safety {
    font-family: "spoqa700";
    font-size: 0.88em;
    color: #73972c;
    width: 30px;
  }
  .env-item-Warning {
    font-family: "spoqa700";
    font-size: 0.88em;
    color: #ff9900;
    position: absolute;
    right: 25px;
    width: 30px;
  }
  .env-item-color {
    margin-top: 6px;
    margin-bottom: 12px;
    width: 12px;
    height: 102px;
    border-radius: 9px;

    background: linear-gradient(
      180deg,
      #ff0000 -0.49%,
      #ff9900 49.51%,
      #73972c 99.51%
    );
  }
  @media screen and (min-width: 1050px) {
    font-size: 1.13em;
    .env-item-color {
      width: 14px;
      height: 112px;
    }
    .env-item-Warning {
      right: 35px;
    }
  }
`;
export const EnvironmentalItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  /* min-width: 80px; */
  height: 100%;
  margin-left: 20px;
  &:first-child {
    margin: 0;
  }

  .env-item-title {
    font-family: "spoqa400";
    color: #656565;
    font-size: 0.75em;
  }
  .env-item-value {
    font-family: "spoqa700";
    font-size: 0.63em;
  }
  /* .env-item-color{
    margin-top: 6px;
    margin-bottom: 12px;
    width: 12px;
    height: 102px;
    border-radius: 9px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border:1px solid skyblue
  } */
  .env-item-color {
    width: 14px;
    height: 112px;
    position: relative;
    & p {
      position: absolute;
      width: 38px;
      height: 38px;
      border-radius: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  @media screen and (min-width: 1050px) {
    /* min-width: 100px; */
    /* background-color: orange; */
    width: 120px;
    font-size: 1.13em;
    margin-left: 40px;
    .env-item-title {
      font-family: "spoqa400";
      color: #656565;
      font-size: 0.88em;
    }
    .env-item-value {
      font-family: "spoqa700";
      font-size: 0.88em;
    }
    .env-item-color {
      width: 14px;
      height: 112px;
      position: relative;
      & p {
        position: absolute;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
`;

export const InsectAge = styled.div`
  width: 100%;
  padding: 20px 40px 40px 40px;
  margin-top: 10px;
  background-color: #fff;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;

  & .content-tit {
    font-size: 1em;
    font-family: "spoqa700";
    margin-bottom: 18px;
  }

  & select {
    width: 50%;
    padding: 10px 0;
    border: 1px solid #c9c9c9c9;
    border-radius: 3px;
    font-size: 0.88em;
    margin-bottom: 18px;
    -o-appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url("./img/ArrowBot.svg") no-repeat;
    background-position: 98% 50%;
    padding-left: 10px;
  }

  @media screen and (min-width: 1050px) {
    .content-tit {
      font-size: 1.2em;
      font-family: "spoqa700";
    }
    & select::-ms-expand {
      display: none;
    }
    & select {
      font-size: 1.2em;
      -moz-appearance: none;
      appearance: none;
      background: url("./img/ArrowBot.svg") no-repeat;
      background-position: 98% 50%;
    }
  }
`;
export const WorkSelect = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .WorkSelect-list {
    width: 18%;
    padding: 5px 0;
    background-color: #73972c;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
  }
  .WorkSelect-list-active {
    width: 18%;
    padding: 5px 0;
    background-color: #ff9781;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
  }
  .WorkSelect-list-img {
    margin-right: 8px;
  }
  .WorkSelect-list-img img {
    width: 90%;
  }
  .WorkSelect-list-text {
    font-size: 0.88em;
    font-family: "spoqa500";
    color: #fff;
  }

  @media screen and (min-width: 1050px) {
    .WorkSelect-list-text {
      font-size: 1.2em;
    }
    .WorkSelect-list-img {
      margin-right: 5px;
    }
  }
`;

export const WorkSelector = styled.div`
  width: 100%;
`;

export const WorkData = styled.div`
  width: 100%;
  padding: 30px 40px;
  margin-top: 8px;
  background-color: #fff;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
  .work-data-top {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    & .work-data-title {
      color: #ff9781;
      font-size: 1em;
      font-family: "spoqa700";
    }

    & input[type="date"],
    input[type="time"] {
      margin-left: 10px;
      border: 1px solid #dddddd;
      padding: 3px 5px;
      font-size: 0.88em;
      border-radius: 5px;
      color: #656565;
    }

    & .work-data-arrow {
      position: absolute;
      top: 0;
      right: 0;
      & img {
        width: 100%;
        transform: rotate(0deg);
        transition-duration: 1s;
        cursor: pointer;
        &.rotate {
          transform: rotate(180deg);
          transition-duration: 1s;
          cursor: pointer;
        }
      }
    }
  }
  @media screen and (min-width: 1050px) {
    .work-data-top {
      width: 100%;

      & .work-data-title {
        font-size: 1.2em;
      }
      & input[type="date"],
      input[type="time"] {
        padding: 5px 10px;
        font-size: 1em;
        border-radius: 5px;
      }
      & .work-data-arrow {
        width: 20px;
        & img {
          width: 100%;
        }
      }
    }
  }
`;
export const WorkItemBox = styled.div`
  width: 100%;
  max-height: 1000px;
  transition-duration: 1s;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  overflow: hidden;
  &.hide {
    overflow: hidden;
    max-height: 0px;
    transition-duration: 1s;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`;

export const WorkItem = styled.div`
  width: 49%;
  margin-top: 12px;

  &:nth-child(2n) {
    margin-left: 2%;
  }
  .work-item-top {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    & .work-item-title {
      font-size: 0.88em;
      color: #656565;
      font-family: "spoqa400";
    }

    & .work-item-unit {
      font-size: 0.75em;
      color: #656565;
      font-family: "spoqa400";
    }
  }

  input[type="text"],
  select {
    width: 100%;
    height: 38px;
    margin-top: 5px;
    border-radius: 3px;
    font-size: 0.88em;
    padding: 8px 10px;
    border: 1px solid #dddddd;
    color: #2a3a4b;
  }

  @media screen and (min-width: 1050px) {
    .work-item-top {
      & .work-item-title {
        font-size: 1.1em;
      }

      & .work-item-unit {
        font-size: 1em;
      }
    }
    input[type="text"],
    select {
      height: 50px;
      font-size: 1.1em;
      border: 1px solid #dddddd;
    }
  }
`;
export const CleaningCheckBox = styled.div`
  width: 50%;
  padding: 10px 0px;

  label {
    font-size: 0.88em;
    font-family: "spoqa400";
    color: #656565;
    position: relative;

    &:last-child {
      /* margin-left: 75px; */
    }
  }
  input[type="checkbox"] {
    appearance: none;
    width: 38px;
    height: 38px;
    border: 1px solid #dddddd;
    margin-right: 8px;
    position: relative;
    top: 10px;

    &:checked {
      border-color: transparent;
      background-image: url("./img/circle.svg");
      background-size: 90% 90%;
      background-position: 50%;
      background-repeat: no-repeat;
      border: 1px solid #dddddd;
    }
  }
  @media screen and (min-width: 1050px) {
    width: 50%;
    padding: 10px 0px;

    label {
      font-size: 1em;
      font-family: "spoqa400";
      color: #656565;
      position: relative;

      &:last-child {
        /* margin-left: 75px; */
      }
    }
    input[type="checkbox"] {
      appearance: none;
      width: 45px;
      height: 45px;
      border: 1px solid #dddddd;
      margin-right: 8px;
      position: relative;
      top: 13px;

      &:checked {
        border-color: transparent;
        background-image: url("./img/circle.svg");
        background-size: 90% 90%;
        background-position: 50%;
        background-repeat: no-repeat;
        border: 1px solid #dddddd;
      }
    }
  }
`;

export const CleaningSelect = styled.div`
  width: 50%;
  p {
    font-family: "spoqa400";
    font-size: 0.75em;
    color: #656565;
  }
  select {
    width: 100%;
    height: 38px;
    border: 1px solid #dddddd;
    border-radius: 5px;
    font-size: 0.88em;
    color: #2a3a4b;
    padding: 10px 8px;
    margin-top: 4px;
  }
  @media screen and (min-width: 1050px) {
    p {
      font-family: "spoqa400";
      font-size: 1em;
      color: #656565;
    }
    select {
      width: 100%;
      height: 45px;
      border: 1px solid #dddddd;
      border-radius: 5px;
      font-size: 1.1em;
      color: #2a3a4b;
      padding: 10px 8px;
      margin-top: 8px;
    }
  }
`;
export const DiseaseItem = styled.div`
  width: 100%;
  margin-top: 18px;

  .disease-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    & .disease-title {
      font-size: 0.88em;
      font-family: "spoqa400";
      color: #656565;
    }
    & .disease-unit {
      font-size: 0.75em;
      font-family: "spoqa400";
      color: #656565;
    }

    input[type="text"] {
      width: 100%;
      height: 38px;
      border: 1px solid #dddddd;
      border-radius: 5px;
      margin-top: 4px;
    }
  }

  @media screen and (min-width: 1050px) {
    .disease-top {
      & .disease-title {
        font-size: 1.1em;
      }
      & .disease-unit {
        font-size: 1em;
      }

      input[type="text"] {
        height: 45px;
        margin-top: 8px;
      }
    }
  }
`;

export const Memo = styled.div`
  width: 100%;
  padding: 20px 40px 55px 40px;
  background-color: #fff;
  margin-top: 10px;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;

  .content-tit {
    font-size: 1em;
    font-family: "spoqa700";
    margin-bottom: 10px;
  }
  textarea {
    width: 100%;
    height: 78px;
    border: 1px solid #dddddd;
    background-color: #e7e7e7e7;
    border-radius: 3px;
  }

  @media screen and (min-width: 1050px) {
    .content-tit {
      font-size: 1.2em;
      margin-bottom: 20px;
    }

    textarea {
      height: 300px;
      font-size: 1.2em;
      letter-spacing: 0.5px;
    }
  }
`;
export const DiseaseBot = styled.div`
  width: 100%;
`;
export const DiseaseMemo = styled.div`
  padding: 20px 40px 31px 40px;
  background-color: #fff;
  margin-top: 8px;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;

  & p {
    font-family: "spoqa700";
    font-size: 1em;
    color: #2a3a4b;
  }
  & textarea {
    width: 100%;
    height: 78px;
    border: 1px solid #dddddd;
    background-color: #f7f7f7;
    border-radius: 5px;
    padding: 8px;
    font-size: 0.88em;
    margin-top: 10px;
  }

  @media screen and (min-width: 1050px) {
    & p {
      font-size: 1.2em;
    }
    & textarea {
      width: 100%;
      height: 300px;
      border: 1px solid #dddddd;
      background-color: #f7f7f7;
      border-radius: 5px;
      padding: 8px;
      font-size: 1em;
      margin-top: 10px;
    }
  }
`;
export const DiseaseLink = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
  margin-top: 8px;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
  padding: 30px 0px;

  & p {
    font-size: 1.13em;
    color: #2a3a4b;
    line-height: 1.5;
  }
  & button {
    width: 40%;
    background-color: #ffaa6c;
    font-size: 1em;
    color: #fff;
    cursor: pointer;
    padding: 10px 0px;
    margin-top: 20px;
    border-radius: 5px;
    border: none;
  }
  @media screen and (min-width: 1050px) {
    & p {
      font-size: 1.4em;
      color: #2a3a4b;
      line-height: 1.7;
    }
    & button {
      width: 40%;
      background-color: #ffaa6c;
      font-size: 1.2em;
      color: #fff;
      cursor: pointer;
      padding: 20px 0px;
      margin-top: 20px;
      border-radius: 5px;
      border: none;
    }
  }
`;
export const ImageUpload = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  input[type="file"] {
    position: absolute;
    width: 0;
    height: 0;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
  label {
    cursor: pointer;
    & .camera-btn {
      width: 60px;
      height: 60px;
      border-radius: 3px;
      background-color: #dddddd;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;

      & .camera-img {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60%;
      }

      & .total-img {
        font-size: 0.69em;
        font-family: "spoqa500";
        height: 40%;
      }
    }
  }
  .disease-img-title {
    font-size: 0.85em;
    color: #2a3a4b;
    margin-top: 18px;
    margin-bottom: 6px;
    width: 100%;
  }
  @media screen and (min-width: 1050px) {
    .content-tit {
      font-size: 1.2em;
      margin-bottom: 20px;
    }
    label {
      cursor: pointer;
      & .camera-btn {
        width: 100px;
        height: 100px;
        border-radius: 3px;
        background-color: #dddddd;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        & .camera-img {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 60%;

          & img {
            width: 50%;
          }
        }

        & .total-img {
          font-size: 1.2em;
          font-family: "spoqa500";
          height: 40%;
        }
      }
    }

    textarea {
      height: 300px;
      font-size: 1.2em;
      letter-spacing: 0.5px;
    }

    .disease-img-title {
      font-size: 1em;
    }
  }
`;

export const PreviewIamge = styled.div`
  width: 60px;
  height: 60px;
  margin-left: 10px;
  position: relative;
  & img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  & p {
    width: 10px;
    height: 10px;
    background-color: #eee;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 2px;
    right: 2px;
    z-index: 999;
    cursor: pointer;
  }

  @media screen and (min-width: 1050px) {
    width: 100px;
    height: 100px;

    & p {
      width: 15px;
      height: 15px;
    }
  }
`;

export const DiaryDetailFormContainer = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
`;

export const DiaryDataContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 8px;
`;

export const DiaryDataLeftBox = styled.div`
  width: 68%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  @media screen and (min-width: 1050px) {
    width: calc(100% - 320px);
  }
`;

export const DiaryDataLeftBoxTop = styled.div`
  width: 100%;
  padding: 0px 17px 26px 40px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
`;
export const DiaryDataLeftBoxTopItem = styled.div`
  width: 100%;
  background-color: #fff;
  padding: 24px 17px 0px 40px;

  .work-data-top {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    & .work-data-title {
      font-size: 1em;
      font-family: "spoqa700";
      color: #ff9781;
    }

    & input {
      margin-left: 1em;
      border: 1px solid #dddddd;
      padding: 3px 5px;
      font-size: 0.88em;
      border-radius: 5px;
      color: #656565;
    }
  }
`;

export const DiaryDataLeftBoxBot = styled.div`
  width: 100%;
  padding: 20px 17px 20px 40px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 8px;
`;
export const BeforeDataModal = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  & .modal {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    & .modal-item {
      width: 100%;
      /* height: 500px; */
      background-color: #fff;
      position: relative;

      & .modal-off-btn {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
  &.modal-open {
    display: block;
  }
  &.modal-close {
    display: none;
  }
`;
export const ImageModal = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  & .modal {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &.modal-open {
    display: block;
  }
  &.modal-close {
    display: none;
  }
  & .imagebox {
    /* background-color: orange; */
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    & img {
      width: 30%;
      /* max-height: 500px;  필요하면 값 계산해서 적용*/
    }
  }
`;
export const DiaryDataRightBox = styled.div`
  width: 31%;
  /* background-color: #dddddd; */
  margin-left: 1%;
  padding: 10px 20px 44px 20px;
  position: relative;
  & .rightbox-btn {
    position: absolute;
    top: 5px;
    left: 0;
    transform: rotate(270deg);
    cursor: pointer;
  }
  & .right-box-date {
    width: 100%;
    color: #2a3a4b;
    font-size: 0.75em;
  }

  & button {
    background-color: #537ff9;
    padding: 8px 12px;
    color: #fff;
    font-size: 0.88em;
    border: none;
    border-radius: 5px;
    margin: 0 auto;
    margin-top: 11px;
  }

  & .breeding-box-title {
    font-size: 0.75em;
    color: #656565;
    margin-top: 13px;
  }

  & .breeding-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 5px;

    & .breeding-item {
      padding: 5px 8px;
      border: 1px solid #656565;
      color: #656565;
      border-radius: 5px;
      font-size: 0.63em;
      margin-left: 5px;
    }
  }
  .border-fff {
    width: 100%;
    border-top: 1px solid #f1f1f1;
    margin-top: 16px;
  }
  .right-box-data {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 13px;
    & .right-box-content {
      color: #656565;
      font-size: 0.75em;
    }

    & .right-box-value {
      font-size: 0.75em;
      color: #2a3a4b;
    }
  }
  @media screen and (min-width: 1050px) {
    width: 320px;
    margin-left: 10px;
    /* transform: translateX(300px); */
    & .right-box-date {
      font-size: 1em;
    }

    & button {
      font-size: 1.1em;
    }

    & .breeding-box-title {
      font-size: 1em;
    }

    & .breeding-box {
      & .breeding-item {
        font-size: 0.88em;
      }
    }
    .right-box-data {
      & .right-box-content {
        font-size: 1em;
      }

      & .right-box-value {
        font-size: 1em;
      }
    }
  }
`;

export const BoxLitModal = styled.div`
width: 100%;
height: 100vh;
position: fixed;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
background-color: rgba(0, 0, 0, 0.5);
display: flex;
align-items: center;
justify-content: center;
z-index: 9999;

& .modal {
  width: 30%;
  height: 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(100%, 50%);

  & .modal-item {
    width: 100%;
    background-color: #fff;
    position: relative;
    padding: 20px;

    & .modal-off-btn {
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
    }

    & .checkbox-list {
      display: flex;
      flex-direction: column;

      & .checkbox-item {
        margin-bottom: 10px;

        & input {
          margin-right: 5px;
        }
      }
    }
  }
}

&.modal-open {
  display: block;
  transform: translate(-50%, -50%);
}
&.modal-close {
  display: none;
}
`;